import { render, staticRenderFns } from "./AddCourseOverview.vue?vue&type=template&id=2e400183&scoped=true&"
import script from "./AddCourseOverview.vue?vue&type=script&lang=js&"
export * from "./AddCourseOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e400183",
  null
  
)

export default component.exports